export function initRecentlyPurchasedReportsBanner() {
    'use strict';

    const BANNER_DISMISSED_KEY = 'recentlyPurchasedReportsBannerDismissed';
    const BODY_OFFSET_CLASS = 'has-recently-purchased-reports-banner';

    const banner = document.getElementById('recentlyPurchasedReportsBanner');
    const bannerClose = document.getElementById('recentlyPurchasedReportsBannerClose');
    const bannerLinks = document.querySelectorAll('.recently-purchased-reports-banner__link');

    if (!banner) return;

    const purchasedAt = banner.dataset.purchasedAt || '';

    function showBanner() {
        banner.removeAttribute('hidden');
        document.body.style.setProperty('--recently-purchased-reports-banner-height', `${banner.offsetHeight}px`);
        document.body.classList.add(BODY_OFFSET_CLASS);
        window.foolTrackEvent?.('RecentlyPurchasedReportsBannerViewed');
    }

    function sendDismissRequest() {
        fetch(banner.dataset.dismissUrl, {
            method: 'POST',
            headers: { 'X-WP-Nonce': banner.dataset.dismissNonce },
        }).then((response) => {
            if (!response.ok) {
                throw new Error(`Dismiss request failed with status ${response.status}`);
            }
        }).catch((error) => {
            console.error('Error dismissing recently purchased reports banner:', error);
            if (window.newrelic) {
                window.newrelic.noticeError(error);
            }
        });
    }

    function dismissBanner() {
        banner.setAttribute('hidden', '');
        document.body.classList.remove(BODY_OFFSET_CLASS);
        localStorage.setItem(BANNER_DISMISSED_KEY, purchasedAt);
        window.foolTrackEvent?.('RecentlyPurchasedReportsBannerDismissed');
        sendDismissRequest();
    }

    if (localStorage.getItem(BANNER_DISMISSED_KEY) !== purchasedAt) {
        showBanner();
    }

    if (bannerClose) {
        bannerClose.addEventListener('click', dismissBanner);
    }

    bannerLinks.forEach((link) => {
        link.addEventListener('click', () => {
            window.foolTrackEvent?.('RecentlyPurchasedReportsBannerClicked', {
                destination: link.href,
                reportName: link.dataset.reportName || '',
            });
        });
    });
}
